import { I18nTypes, refDataValues } from '@diagentech/exprworks-rule-engine';
import { createSelector } from 'reselect';

import { CodeTableRef } from '@/App/types';
import { ActionRef } from '@/App/types/actionRef';
import { ScreenRef } from '@/App/types/screenRef';
import { getDisplayRulesMetadata } from '@/features/displayRules/getDisplayRulesMetadata';
import { selectDisplayRuleStateMap } from '@/features/displayRules/selectDisplayRuleStateMap';
import { selectScreenRefDataMap } from '@/features/refdata/selectScreenRefDataMap';

export const selectRefDataValues = (screen: ScreenRef, action: ActionRef, id: I18nTypes) =>
  createSelector([selectScreenRefDataMap, selectDisplayRuleStateMap], (screenRefDataMap, displayRules) => {
    const meta = getDisplayRulesMetadata(displayRules, screen, action);
    if (!meta || !meta[id]) {
      return [];
    }
    const fieldMeta = meta[id];
    return refDataValues(fieldMeta.codeTables as CodeTableRef, screenRefDataMap[screen]);
  });
